// extracted by mini-css-extract-plugin
export default {"monitoringContainer":"ComplitedMonitoring_monitoringContainer__V8J2u"};